var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 8.5C4.12708 4.4446 7.80667 1.5 12.1553 1.5C16.5039 1.5 20.1835 4.4446 21.4102 8.5M21.4102 8.5L18.0481 7.42308M21.4102 8.5L22.5004 5.13462",
    stroke: "#F59D0E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.1C21.1857 18.1554 17.2433 21.1 12.584 21.1C7.9248 21.1 3.98238 18.1554 2.66807 14.1M2.66807 14.1L6.27034 15.177M2.66807 14.1L1.5 17.4654",
    stroke: "#F59D0E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.23bb3825f3abdcb22102f4dd807f0bf8.svg";
export { ForwardRef as ReactComponent };